import { NgModule } from "@angular/core";
import { MeshLoader } from "./mesh-loader";
import { PngDecoder } from "./png-decoder";
import { RenderBatch } from "./render-batch";
import { TextureLoader } from "./texture-loader";
var RenderModule = (function () {
    function RenderModule() {
    }
    RenderModule.decorators = [
        { type: NgModule, args: [{
                    providers: [MeshLoader, PngDecoder, RenderBatch, TextureLoader]
                },] },
    ];
    RenderModule.ctorParameters = function () { return []; };
    return RenderModule;
}());
export { RenderModule };
;
//# sourceMappingURL=render.module.js.map